// extracted by mini-css-extract-plugin
export var exit = "_6-3";
export var notificationContainer = "_6-1";
export var notificationStack = "_6-0";
export var shrinkFadeOut = "_6-4";
export var slideInUp = "_6-2";